var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: this.creatorStudio.settings.prompt_modifier.includes(_vm.prompt)
        ? "prompt-selected"
        : "prompt",
      on: { click: _vm.addPrompt },
    },
    [_c("span", [_vm._v(_vm._s(_vm.prompt))])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }